import { NgSelectModule } from '@ng-select/ng-select';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatCommonModule, MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';

@NgModule({
    imports: [
        MatCommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        NgSelectModule,
        MatChipsModule,
        MatOptionModule,
        MatGridListModule,
        MatProgressBarModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatDialogModule,
        MatSnackBarModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatSidenavModule,
        MatCardModule,
        MatIconModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatListModule,
        MatTreeModule,
        MatButtonToggleModule,
        MatRippleModule,
        MatTableModule,
        MatSortModule,
        MatBadgeModule,
        MatExpansionModule,
        ReactiveFormsModule,
        CdkStepperModule,
        MatPaginatorModule,
        MatAutocompleteModule,
        MatTooltipModule,
    ],
    exports: [
        MatCommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        NgSelectModule,
        MatChipsModule,
        MatOptionModule,
        MatGridListModule,
        MatProgressBarModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatDialogModule,
        MatSnackBarModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatSidenavModule,
        MatCardModule,
        MatIconModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatListModule,
        MatTreeModule,
        MatButtonToggleModule,
        MatRippleModule,
        MatTableModule,
        MatSortModule,
        MatBadgeModule,
        MatExpansionModule,
        ReactiveFormsModule,
        CdkStepperModule,
        MatPaginatorModule,
        MatAutocompleteModule,
        MatTooltipModule,
    ],
})
export class MaterialModule {}
